import type React from "react";
import { useEffect } from "react";

export const ThemeProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	// 始终使用深色主题
	useEffect(() => {
		const root = document.documentElement;
		root.setAttribute("data-theme", "dark");
		root.className = "dark";
	}, []);

	return <>{children}</>;
};
